module.exports = {
	container: {
		center: true,
		padding: {
			DEFAULT: "2rem",
			"lg": "9.375rem",
		},
	},
	extend: {
		fontFamily: {
			montserrat: ["Montserrat", "sans-serif"],
		},
		screens: {
			"0": "425px",
			sm: "640px",
			md: "768px",
			lg: "1024px",
			// xl: "1330px",
			xl: "1280px",
			// "2xl": "1330px",
			"2xl": "1440px",
			"lg-down": {
				max: "1329px",
			},
			"md-down": {
				max: "1023px",
			},
			"sm-down": {
				max: "767px",
			},
			"sm-only": {
				max: "669px",
			},
		},
		// colors: {
		// 	transparent: "transparent",
		// 	current: "currentColor",
		// 	"body-background": "#ffffff",
		// 	black: "#000000",
		// 	white: "#ffffff",
		// 	primary: {
		// 		DEFAULT: "#FA7221",
		// 		50: "#FDCBAD",
		// 		100: "#FDBE99",
		// 		200: "#FCA571",
		// 		300: "#FB8B49",
		// 		400: "#FA7221",
		// 		500: "#DE5605",
		// 		600: "#A74104",
		// 		700: "#702B03",
		// 		800: "#391601",
		// 		900: "#020100",
		// 		950: "#000000",
		// 	},
		// 	secondary: {
		// 		DEFAULT: "#F22F80",
		// 		50: "#FAB5D2",
		// 		100: "#F9A2C6",
		// 		200: "#F77CAF",
		// 		300: "#F45597",
		// 		400: "#F22F80",
		// 		500: "#DB0E63",
		// 		600: "#A60A4B",
		// 		700: "#720733",
		// 		800: "#3D041B",
		// 		900: "#080104",
		// 		950: "#000000",
		// 	},
		// 	accent: {
		// 		DEFAULT: "#12BADC",
		// 		50: "#88E3F5",
		// 		100: "#75DEF4",
		// 		200: "#4FD5F1",
		// 		300: "#29CCEE",
		// 		400: "#12BADC",
		// 		500: "#0E8EA8",
		// 		600: "#0A6274",
		// 		700: "#053640",
		// 		800: "#010B0D",
		// 		900: "#000000",
		// 		950: "#000000",
		// 	},
		// 	green: {
		// 		DEFAULT: "#12BADC",
		// 		50: "#88E3F5",
		// 		100: "#75DEF4",
		// 		200: "#4FD5F1",
		// 		300: "#29CCEE",
		// 		400: "#12BADC",
		// 		500: "#0E8EA8",
		// 		600: "#0A6274",
		// 		700: "#053640",
		// 		800: "#010B0D",
		// 		900: "#000000",
		// 		950: "#000000",
		// 	},
		// },
		colors: {
			transparent: "transparent",
			current: "currentColor",
			"body-background": "#ffffff",
			black: "#000000",
			white: "#ffffff",
			"mine-shaft": "#333",
			sushi: "#94BA33",
			cerulean: "#00ABDC",
			"regal-blue": "#003F66",
		},
		margin: {
			container: "15px",
		},
		borderRadius: {
			button: "23px",
		},
		boxShadow: {
			card: "0 10px 20px 0px rgba(0, 0, 0, 0.07)",
			callout: "0 10px 20px 0px rgba(0, 0, 0, 0.15)",
		},
	},
};
